import { Component } from "../bootstrap/component";
import { body } from "../bootstrap/elements";
import { getFileContent } from "../bootstrap/frontbox";

export type IFloatingInformationStates = {
  doing: boolean;
  visible: boolean;
}

export interface IFloatingInformationElement {
  title: string;
  content: string;
  link: string;
  button: HTMLElement
}

export class FloatingInformationService extends Component {
  private el: HTMLElement;
  private initialized: boolean;
  private states: IFloatingInformationStates;

  private activeButton: HTMLElement

  private title: HTMLElement;
  private content: HTMLElement;
  private link: HTMLElement;

  private clickOutsideEvent: EventListenerOrEventListenerObject;

  public onInit() {
    this.states = {
      doing: false,
      visible: false,
    };

    this.clickOutsideEvent = (e: MouseEvent) => {
      this.clickOutside(e);
    }
  }

  public async initialize() {
    body.insertAdjacentHTML('beforeend', await getFileContent(`/fl-intervention/partials/floating-information.template.html`));

    this.el = document.getElementById('floatingInformation');
    this.title = document.getElementById('floatingInformationTitle');
    this.content = document.getElementById('floatingInformationContent');
    this.link = document.getElementById('floatingInformationLink');

    this.initialized = true;

    return new Promise(r => setTimeout(r, 100));
  }

  public async open(params: IFloatingInformationElement) {
    const { title, content, link, button } = params;

    if (this.states.doing) {
      return;
    }

    if (this.activeButton) {
      this.activeButton.classList.remove('isActive');
    }

    button.classList.add('isActive');

    this.activeButton = button;

    this.changeState({
      doing: true
    });

    if (!this.initialized) {
      await this.initialize();
    }

    this.title.innerHTML = title;
    this.content.innerHTML = content;
    this.link.setAttribute('href', '/fl-intervention/' + link);

    this.changeState({
      doing: false,
      visible: true
    });

    document.addEventListener('click', this.clickOutsideEvent, true);
  }

  public clickOutside(event: MouseEvent): void {
    const canClose: boolean | number = event.composedPath().indexOf(this.el);

    if (((event.target) as HTMLElement).getAttribute('data-fi')) {
      return
    }

    if (canClose === -1) {
      this.close();
    }
  }

  public close() {
    if (this.states.doing) {
      return;
    }

    this.changeState({
      doing: true,
      visible: false,
    });

    setTimeout(() => {
      this.title.innerHTML = '';
      this.content.innerHTML = '';

      if (this.activeButton) {
        this.activeButton.classList.remove('isActive');

        this.activeButton = null;
      }

      this.changeState({
        doing: false,
      });
    }, 200);

    document.removeEventListener('click', this.clickOutsideEvent, true);
  }

  public changeState(states: Partial<IFloatingInformationStates>) {
    for (const state in states) {
      if (states.hasOwnProperty(state)) {
        const value = states[state];

        this.states[state] = value;

        if (this.el) {
          if (value) {
            this.el.classList.add(`is-${state}`);
          } else {
            this.el.classList.remove(`is-${state}`);
          }
        }
      }
    }
  }
}